/*eslint-disable block-scoped-var, id-length, no-control-regex, no-magic-numbers, no-prototype-builtins, no-redeclare, no-shadow, no-var, sort-vars*/
import * as $protobuf from "protobufjs/minimal";

// Common aliases
const $Reader = $protobuf.Reader, $Writer = $protobuf.Writer, $util = $protobuf.util;

// Exported root namespace
const $root = $protobuf.roots["default"] || ($protobuf.roots["default"] = {});

export const Document = $root.Document = (() => {

    /**
     * Properties of a Document.
     * @exports IDocument
     * @interface IDocument
     * @property {string|null} [key] Document key
     * @property {Array.<IBlock>|null} [nodes] Document nodes
     * @property {Object.<string,string>|null} [data] Document data
     */

    /**
     * Constructs a new Document.
     * @exports Document
     * @classdesc Represents a Document.
     * @implements IDocument
     * @constructor
     * @param {IDocument=} [properties] Properties to set
     */
    function Document(properties) {
        this.nodes = [];
        this.data = {};
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null && keys[i] !== "__proto__")
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * Document key.
     * @member {string} key
     * @memberof Document
     * @instance
     */
    Document.prototype.key = "";

    /**
     * Document nodes.
     * @member {Array.<IBlock>} nodes
     * @memberof Document
     * @instance
     */
    Document.prototype.nodes = $util.emptyArray;

    /**
     * Document data.
     * @member {Object.<string,string>} data
     * @memberof Document
     * @instance
     */
    Document.prototype.data = $util.emptyObject;

    /**
     * Creates a new Document instance using the specified properties.
     * @function create
     * @memberof Document
     * @static
     * @param {IDocument=} [properties] Properties to set
     * @returns {Document} Document instance
     */
    Document.create = function create(properties) {
        return new Document(properties);
    };

    /**
     * Encodes the specified Document message. Does not implicitly {@link Document.verify|verify} messages.
     * @function encode
     * @memberof Document
     * @static
     * @param {IDocument} message Document message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    Document.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.key != null && Object.hasOwnProperty.call(message, "key"))
            writer.uint32(/* id 1, wireType 2 =*/10).string(message.key);
        if (message.nodes != null && message.nodes.length)
            for (let i = 0; i < message.nodes.length; ++i)
                $root.Block.encode(message.nodes[i], writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
        if (message.data != null && Object.hasOwnProperty.call(message, "data"))
            for (let keys = Object.keys(message.data), i = 0; i < keys.length; ++i)
                writer.uint32(/* id 3, wireType 2 =*/26).fork().uint32(/* id 1, wireType 2 =*/10).string(keys[i]).uint32(/* id 2, wireType 2 =*/18).string(message.data[keys[i]]).ldelim();
        return writer;
    };

    /**
     * Encodes the specified Document message, length delimited. Does not implicitly {@link Document.verify|verify} messages.
     * @function encodeDelimited
     * @memberof Document
     * @static
     * @param {IDocument} message Document message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    Document.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer && writer.len ? writer.fork() : writer).ldelim();
    };

    /**
     * Decodes a Document message from the specified reader or buffer.
     * @function decode
     * @memberof Document
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {Document} Document
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    Document.decode = function decode(reader, length, error, long) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        if (long === undefined)
            long = 0;
        if (long > $Reader.recursionLimit)
            throw Error("maximum nesting depth exceeded");
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.Document(), key, value;
        while (reader.pos < end) {
            let tag = reader.uint32();
            if (tag === error)
                break;
            switch (tag >>> 3) {
            case 1: {
                    message.key = reader.string();
                    break;
                }
            case 2: {
                    if (!(message.nodes && message.nodes.length))
                        message.nodes = [];
                    message.nodes.push($root.Block.decode(reader, reader.uint32(), undefined, long + 1));
                    break;
                }
            case 3: {
                    if (message.data === $util.emptyObject)
                        message.data = {};
                    let end2 = reader.uint32() + reader.pos;
                    key = "";
                    value = "";
                    while (reader.pos < end2) {
                        let tag2 = reader.uint32();
                        switch (tag2 >>> 3) {
                        case 1:
                            key = reader.string();
                            break;
                        case 2:
                            value = reader.string();
                            break;
                        default:
                            reader.skipType(tag2 & 7, long);
                            break;
                        }
                    }
                    if (key === "__proto__")
                        $util.makeProp(message.data, key);
                    message.data[key] = value;
                    break;
                }
            default:
                reader.skipType(tag & 7, long);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a Document message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof Document
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {Document} Document
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    Document.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a Document message.
     * @function verify
     * @memberof Document
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    Document.verify = function verify(message, long) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (long === undefined)
            long = 0;
        if (long > $util.recursionLimit)
            return "maximum nesting depth exceeded";
        if (message.key != null && message.hasOwnProperty("key"))
            if (!$util.isString(message.key))
                return "key: string expected";
        if (message.nodes != null && message.hasOwnProperty("nodes")) {
            if (!Array.isArray(message.nodes))
                return "nodes: array expected";
            for (let i = 0; i < message.nodes.length; ++i) {
                let error = $root.Block.verify(message.nodes[i], long + 1);
                if (error)
                    return "nodes." + error;
            }
        }
        if (message.data != null && message.hasOwnProperty("data")) {
            if (!$util.isObject(message.data))
                return "data: object expected";
            let key = Object.keys(message.data);
            for (let i = 0; i < key.length; ++i)
                if (!$util.isString(message.data[key[i]]))
                    return "data: string{k:string} expected";
        }
        return null;
    };

    /**
     * Creates a Document message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof Document
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {Document} Document
     */
    Document.fromObject = function fromObject(object, long) {
        if (object instanceof $root.Document)
            return object;
        if (long === undefined)
            long = 0;
        if (long > $util.recursionLimit)
            throw Error("maximum nesting depth exceeded");
        let message = new $root.Document();
        if (object.key != null)
            message.key = String(object.key);
        if (object.nodes) {
            if (!Array.isArray(object.nodes))
                throw TypeError(".Document.nodes: array expected");
            message.nodes = [];
            for (let i = 0; i < object.nodes.length; ++i) {
                if (typeof object.nodes[i] !== "object")
                    throw TypeError(".Document.nodes: object expected");
                message.nodes[i] = $root.Block.fromObject(object.nodes[i], long + 1);
            }
        }
        if (object.data) {
            if (typeof object.data !== "object")
                throw TypeError(".Document.data: object expected");
            message.data = {};
            for (let keys = Object.keys(object.data), i = 0; i < keys.length; ++i) {
                if (keys[i] === "__proto__")
                    $util.makeProp(message.data, keys[i]);
                message.data[keys[i]] = String(object.data[keys[i]]);
            }
        }
        return message;
    };

    /**
     * Creates a plain object from a Document message. Also converts values to other types if specified.
     * @function toObject
     * @memberof Document
     * @static
     * @param {Document} message Document
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    Document.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        let object = {};
        if (options.arrays || options.defaults)
            object.nodes = [];
        if (options.objects || options.defaults)
            object.data = {};
        if (options.defaults)
            object.key = "";
        if (message.key != null && message.hasOwnProperty("key"))
            object.key = message.key;
        if (message.nodes && message.nodes.length) {
            object.nodes = [];
            for (let j = 0; j < message.nodes.length; ++j)
                object.nodes[j] = $root.Block.toObject(message.nodes[j], options);
        }
        let keys2;
        if (message.data && (keys2 = Object.keys(message.data)).length) {
            object.data = {};
            for (let j = 0; j < keys2.length; ++j) {
                if (keys2[j] === "__proto__")
                    $util.makeProp(object.data, keys2[j]);
                object.data[keys2[j]] = message.data[keys2[j]];
            }
        }
        return object;
    };

    /**
     * Converts this Document to JSON.
     * @function toJSON
     * @memberof Document
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    Document.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the default type url for Document
     * @function getTypeUrl
     * @memberof Document
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */
    Document.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/Document";
    };

    return Document;
})();

export const Block = $root.Block = (() => {

    /**
     * Properties of a Block.
     * @exports IBlock
     * @interface IBlock
     * @property {string|null} [key] Block key
     * @property {string|null} [type] Block type
     * @property {Array.<INode>|null} [nodes] Block nodes
     * @property {Array.<IFragment>|null} [fragments] Block fragments
     * @property {Object.<string,string>|null} [data] Block data
     * @property {boolean|null} [isVoid] Block isVoid
     */

    /**
     * Constructs a new Block.
     * @exports Block
     * @classdesc Represents a Block.
     * @implements IBlock
     * @constructor
     * @param {IBlock=} [properties] Properties to set
     */
    function Block(properties) {
        this.nodes = [];
        this.fragments = [];
        this.data = {};
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null && keys[i] !== "__proto__")
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * Block key.
     * @member {string} key
     * @memberof Block
     * @instance
     */
    Block.prototype.key = "";

    /**
     * Block type.
     * @member {string} type
     * @memberof Block
     * @instance
     */
    Block.prototype.type = "";

    /**
     * Block nodes.
     * @member {Array.<INode>} nodes
     * @memberof Block
     * @instance
     */
    Block.prototype.nodes = $util.emptyArray;

    /**
     * Block fragments.
     * @member {Array.<IFragment>} fragments
     * @memberof Block
     * @instance
     */
    Block.prototype.fragments = $util.emptyArray;

    /**
     * Block data.
     * @member {Object.<string,string>} data
     * @memberof Block
     * @instance
     */
    Block.prototype.data = $util.emptyObject;

    /**
     * Block isVoid.
     * @member {boolean} isVoid
     * @memberof Block
     * @instance
     */
    Block.prototype.isVoid = false;

    /**
     * Creates a new Block instance using the specified properties.
     * @function create
     * @memberof Block
     * @static
     * @param {IBlock=} [properties] Properties to set
     * @returns {Block} Block instance
     */
    Block.create = function create(properties) {
        return new Block(properties);
    };

    /**
     * Encodes the specified Block message. Does not implicitly {@link Block.verify|verify} messages.
     * @function encode
     * @memberof Block
     * @static
     * @param {IBlock} message Block message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    Block.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.key != null && Object.hasOwnProperty.call(message, "key"))
            writer.uint32(/* id 1, wireType 2 =*/10).string(message.key);
        if (message.type != null && Object.hasOwnProperty.call(message, "type"))
            writer.uint32(/* id 2, wireType 2 =*/18).string(message.type);
        if (message.nodes != null && message.nodes.length)
            for (let i = 0; i < message.nodes.length; ++i)
                $root.Node.encode(message.nodes[i], writer.uint32(/* id 3, wireType 2 =*/26).fork()).ldelim();
        if (message.fragments != null && message.fragments.length)
            for (let i = 0; i < message.fragments.length; ++i)
                $root.Fragment.encode(message.fragments[i], writer.uint32(/* id 4, wireType 2 =*/34).fork()).ldelim();
        if (message.data != null && Object.hasOwnProperty.call(message, "data"))
            for (let keys = Object.keys(message.data), i = 0; i < keys.length; ++i)
                writer.uint32(/* id 5, wireType 2 =*/42).fork().uint32(/* id 1, wireType 2 =*/10).string(keys[i]).uint32(/* id 2, wireType 2 =*/18).string(message.data[keys[i]]).ldelim();
        if (message.isVoid != null && Object.hasOwnProperty.call(message, "isVoid"))
            writer.uint32(/* id 6, wireType 0 =*/48).bool(message.isVoid);
        return writer;
    };

    /**
     * Encodes the specified Block message, length delimited. Does not implicitly {@link Block.verify|verify} messages.
     * @function encodeDelimited
     * @memberof Block
     * @static
     * @param {IBlock} message Block message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    Block.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer && writer.len ? writer.fork() : writer).ldelim();
    };

    /**
     * Decodes a Block message from the specified reader or buffer.
     * @function decode
     * @memberof Block
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {Block} Block
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    Block.decode = function decode(reader, length, error, long) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        if (long === undefined)
            long = 0;
        if (long > $Reader.recursionLimit)
            throw Error("maximum nesting depth exceeded");
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.Block(), key, value;
        while (reader.pos < end) {
            let tag = reader.uint32();
            if (tag === error)
                break;
            switch (tag >>> 3) {
            case 1: {
                    message.key = reader.string();
                    break;
                }
            case 2: {
                    message.type = reader.string();
                    break;
                }
            case 3: {
                    if (!(message.nodes && message.nodes.length))
                        message.nodes = [];
                    message.nodes.push($root.Node.decode(reader, reader.uint32(), undefined, long + 1));
                    break;
                }
            case 4: {
                    if (!(message.fragments && message.fragments.length))
                        message.fragments = [];
                    message.fragments.push($root.Fragment.decode(reader, reader.uint32(), undefined, long + 1));
                    break;
                }
            case 5: {
                    if (message.data === $util.emptyObject)
                        message.data = {};
                    let end2 = reader.uint32() + reader.pos;
                    key = "";
                    value = "";
                    while (reader.pos < end2) {
                        let tag2 = reader.uint32();
                        switch (tag2 >>> 3) {
                        case 1:
                            key = reader.string();
                            break;
                        case 2:
                            value = reader.string();
                            break;
                        default:
                            reader.skipType(tag2 & 7, long);
                            break;
                        }
                    }
                    if (key === "__proto__")
                        $util.makeProp(message.data, key);
                    message.data[key] = value;
                    break;
                }
            case 6: {
                    message.isVoid = reader.bool();
                    break;
                }
            default:
                reader.skipType(tag & 7, long);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a Block message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof Block
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {Block} Block
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    Block.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a Block message.
     * @function verify
     * @memberof Block
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    Block.verify = function verify(message, long) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (long === undefined)
            long = 0;
        if (long > $util.recursionLimit)
            return "maximum nesting depth exceeded";
        if (message.key != null && message.hasOwnProperty("key"))
            if (!$util.isString(message.key))
                return "key: string expected";
        if (message.type != null && message.hasOwnProperty("type"))
            if (!$util.isString(message.type))
                return "type: string expected";
        if (message.nodes != null && message.hasOwnProperty("nodes")) {
            if (!Array.isArray(message.nodes))
                return "nodes: array expected";
            for (let i = 0; i < message.nodes.length; ++i) {
                let error = $root.Node.verify(message.nodes[i], long + 1);
                if (error)
                    return "nodes." + error;
            }
        }
        if (message.fragments != null && message.hasOwnProperty("fragments")) {
            if (!Array.isArray(message.fragments))
                return "fragments: array expected";
            for (let i = 0; i < message.fragments.length; ++i) {
                let error = $root.Fragment.verify(message.fragments[i], long + 1);
                if (error)
                    return "fragments." + error;
            }
        }
        if (message.data != null && message.hasOwnProperty("data")) {
            if (!$util.isObject(message.data))
                return "data: object expected";
            let key = Object.keys(message.data);
            for (let i = 0; i < key.length; ++i)
                if (!$util.isString(message.data[key[i]]))
                    return "data: string{k:string} expected";
        }
        if (message.isVoid != null && message.hasOwnProperty("isVoid"))
            if (typeof message.isVoid !== "boolean")
                return "isVoid: boolean expected";
        return null;
    };

    /**
     * Creates a Block message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof Block
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {Block} Block
     */
    Block.fromObject = function fromObject(object, long) {
        if (object instanceof $root.Block)
            return object;
        if (long === undefined)
            long = 0;
        if (long > $util.recursionLimit)
            throw Error("maximum nesting depth exceeded");
        let message = new $root.Block();
        if (object.key != null)
            message.key = String(object.key);
        if (object.type != null)
            message.type = String(object.type);
        if (object.nodes) {
            if (!Array.isArray(object.nodes))
                throw TypeError(".Block.nodes: array expected");
            message.nodes = [];
            for (let i = 0; i < object.nodes.length; ++i) {
                if (typeof object.nodes[i] !== "object")
                    throw TypeError(".Block.nodes: object expected");
                message.nodes[i] = $root.Node.fromObject(object.nodes[i], long + 1);
            }
        }
        if (object.fragments) {
            if (!Array.isArray(object.fragments))
                throw TypeError(".Block.fragments: array expected");
            message.fragments = [];
            for (let i = 0; i < object.fragments.length; ++i) {
                if (typeof object.fragments[i] !== "object")
                    throw TypeError(".Block.fragments: object expected");
                message.fragments[i] = $root.Fragment.fromObject(object.fragments[i], long + 1);
            }
        }
        if (object.data) {
            if (typeof object.data !== "object")
                throw TypeError(".Block.data: object expected");
            message.data = {};
            for (let keys = Object.keys(object.data), i = 0; i < keys.length; ++i) {
                if (keys[i] === "__proto__")
                    $util.makeProp(message.data, keys[i]);
                message.data[keys[i]] = String(object.data[keys[i]]);
            }
        }
        if (object.isVoid != null)
            message.isVoid = Boolean(object.isVoid);
        return message;
    };

    /**
     * Creates a plain object from a Block message. Also converts values to other types if specified.
     * @function toObject
     * @memberof Block
     * @static
     * @param {Block} message Block
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    Block.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        let object = {};
        if (options.arrays || options.defaults) {
            object.nodes = [];
            object.fragments = [];
        }
        if (options.objects || options.defaults)
            object.data = {};
        if (options.defaults) {
            object.key = "";
            object.type = "";
            object.isVoid = false;
        }
        if (message.key != null && message.hasOwnProperty("key"))
            object.key = message.key;
        if (message.type != null && message.hasOwnProperty("type"))
            object.type = message.type;
        if (message.nodes && message.nodes.length) {
            object.nodes = [];
            for (let j = 0; j < message.nodes.length; ++j)
                object.nodes[j] = $root.Node.toObject(message.nodes[j], options);
        }
        if (message.fragments && message.fragments.length) {
            object.fragments = [];
            for (let j = 0; j < message.fragments.length; ++j)
                object.fragments[j] = $root.Fragment.toObject(message.fragments[j], options);
        }
        let keys2;
        if (message.data && (keys2 = Object.keys(message.data)).length) {
            object.data = {};
            for (let j = 0; j < keys2.length; ++j) {
                if (keys2[j] === "__proto__")
                    $util.makeProp(object.data, keys2[j]);
                object.data[keys2[j]] = message.data[keys2[j]];
            }
        }
        if (message.isVoid != null && message.hasOwnProperty("isVoid"))
            object.isVoid = message.isVoid;
        return object;
    };

    /**
     * Converts this Block to JSON.
     * @function toJSON
     * @memberof Block
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    Block.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the default type url for Block
     * @function getTypeUrl
     * @memberof Block
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */
    Block.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/Block";
    };

    return Block;
})();

export const Node = $root.Node = (() => {

    /**
     * Properties of a Node.
     * @exports INode
     * @interface INode
     * @property {IInline|null} [inline] Node inline
     * @property {IText|null} [text] Node text
     * @property {IBlock|null} [block] Node block
     */

    /**
     * Constructs a new Node.
     * @exports Node
     * @classdesc Represents a Node.
     * @implements INode
     * @constructor
     * @param {INode=} [properties] Properties to set
     */
    function Node(properties) {
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null && keys[i] !== "__proto__")
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * Node inline.
     * @member {IInline|null|undefined} inline
     * @memberof Node
     * @instance
     */
    Node.prototype.inline = null;

    /**
     * Node text.
     * @member {IText|null|undefined} text
     * @memberof Node
     * @instance
     */
    Node.prototype.text = null;

    /**
     * Node block.
     * @member {IBlock|null|undefined} block
     * @memberof Node
     * @instance
     */
    Node.prototype.block = null;

    // OneOf field names bound to virtual getters and setters
    let $oneOfFields;

    /**
     * Node node.
     * @member {"inline"|"text"|"block"|undefined} node
     * @memberof Node
     * @instance
     */
    Object.defineProperty(Node.prototype, "node", {
        get: $util.oneOfGetter($oneOfFields = ["inline", "text", "block"]),
        set: $util.oneOfSetter($oneOfFields)
    });

    /**
     * Creates a new Node instance using the specified properties.
     * @function create
     * @memberof Node
     * @static
     * @param {INode=} [properties] Properties to set
     * @returns {Node} Node instance
     */
    Node.create = function create(properties) {
        return new Node(properties);
    };

    /**
     * Encodes the specified Node message. Does not implicitly {@link Node.verify|verify} messages.
     * @function encode
     * @memberof Node
     * @static
     * @param {INode} message Node message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    Node.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.inline != null && Object.hasOwnProperty.call(message, "inline"))
            $root.Inline.encode(message.inline, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
        if (message.text != null && Object.hasOwnProperty.call(message, "text"))
            $root.Text.encode(message.text, writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
        if (message.block != null && Object.hasOwnProperty.call(message, "block"))
            $root.Block.encode(message.block, writer.uint32(/* id 3, wireType 2 =*/26).fork()).ldelim();
        return writer;
    };

    /**
     * Encodes the specified Node message, length delimited. Does not implicitly {@link Node.verify|verify} messages.
     * @function encodeDelimited
     * @memberof Node
     * @static
     * @param {INode} message Node message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    Node.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer && writer.len ? writer.fork() : writer).ldelim();
    };

    /**
     * Decodes a Node message from the specified reader or buffer.
     * @function decode
     * @memberof Node
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {Node} Node
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    Node.decode = function decode(reader, length, error, long) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        if (long === undefined)
            long = 0;
        if (long > $Reader.recursionLimit)
            throw Error("maximum nesting depth exceeded");
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.Node();
        while (reader.pos < end) {
            let tag = reader.uint32();
            if (tag === error)
                break;
            switch (tag >>> 3) {
            case 1: {
                    message.inline = $root.Inline.decode(reader, reader.uint32(), undefined, long + 1);
                    break;
                }
            case 2: {
                    message.text = $root.Text.decode(reader, reader.uint32(), undefined, long + 1);
                    break;
                }
            case 3: {
                    message.block = $root.Block.decode(reader, reader.uint32(), undefined, long + 1);
                    break;
                }
            default:
                reader.skipType(tag & 7, long);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a Node message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof Node
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {Node} Node
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    Node.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a Node message.
     * @function verify
     * @memberof Node
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    Node.verify = function verify(message, long) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (long === undefined)
            long = 0;
        if (long > $util.recursionLimit)
            return "maximum nesting depth exceeded";
        let properties = {};
        if (message.inline != null && message.hasOwnProperty("inline")) {
            properties.node = 1;
            {
                let error = $root.Inline.verify(message.inline, long + 1);
                if (error)
                    return "inline." + error;
            }
        }
        if (message.text != null && message.hasOwnProperty("text")) {
            if (properties.node === 1)
                return "node: multiple values";
            properties.node = 1;
            {
                let error = $root.Text.verify(message.text, long + 1);
                if (error)
                    return "text." + error;
            }
        }
        if (message.block != null && message.hasOwnProperty("block")) {
            if (properties.node === 1)
                return "node: multiple values";
            properties.node = 1;
            {
                let error = $root.Block.verify(message.block, long + 1);
                if (error)
                    return "block." + error;
            }
        }
        return null;
    };

    /**
     * Creates a Node message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof Node
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {Node} Node
     */
    Node.fromObject = function fromObject(object, long) {
        if (object instanceof $root.Node)
            return object;
        if (long === undefined)
            long = 0;
        if (long > $util.recursionLimit)
            throw Error("maximum nesting depth exceeded");
        let message = new $root.Node();
        if (object.inline != null) {
            if (typeof object.inline !== "object")
                throw TypeError(".Node.inline: object expected");
            message.inline = $root.Inline.fromObject(object.inline, long + 1);
        }
        if (object.text != null) {
            if (typeof object.text !== "object")
                throw TypeError(".Node.text: object expected");
            message.text = $root.Text.fromObject(object.text, long + 1);
        }
        if (object.block != null) {
            if (typeof object.block !== "object")
                throw TypeError(".Node.block: object expected");
            message.block = $root.Block.fromObject(object.block, long + 1);
        }
        return message;
    };

    /**
     * Creates a plain object from a Node message. Also converts values to other types if specified.
     * @function toObject
     * @memberof Node
     * @static
     * @param {Node} message Node
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    Node.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        let object = {};
        if (message.inline != null && message.hasOwnProperty("inline")) {
            object.inline = $root.Inline.toObject(message.inline, options);
            if (options.oneofs)
                object.node = "inline";
        }
        if (message.text != null && message.hasOwnProperty("text")) {
            object.text = $root.Text.toObject(message.text, options);
            if (options.oneofs)
                object.node = "text";
        }
        if (message.block != null && message.hasOwnProperty("block")) {
            object.block = $root.Block.toObject(message.block, options);
            if (options.oneofs)
                object.node = "block";
        }
        return object;
    };

    /**
     * Converts this Node to JSON.
     * @function toJSON
     * @memberof Node
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    Node.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the default type url for Node
     * @function getTypeUrl
     * @memberof Node
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */
    Node.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/Node";
    };

    return Node;
})();

export const Fragment = $root.Fragment = (() => {

    /**
     * Properties of a Fragment.
     * @exports IFragment
     * @interface IFragment
     * @property {string|null} [key] Fragment key
     * @property {string|null} [fragment] Fragment fragment
     * @property {string|null} [type] Fragment type
     * @property {Array.<IBlock>|null} [nodes] Fragment nodes
     */

    /**
     * Constructs a new Fragment.
     * @exports Fragment
     * @classdesc Represents a Fragment.
     * @implements IFragment
     * @constructor
     * @param {IFragment=} [properties] Properties to set
     */
    function Fragment(properties) {
        this.nodes = [];
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null && keys[i] !== "__proto__")
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * Fragment key.
     * @member {string} key
     * @memberof Fragment
     * @instance
     */
    Fragment.prototype.key = "";

    /**
     * Fragment fragment.
     * @member {string} fragment
     * @memberof Fragment
     * @instance
     */
    Fragment.prototype.fragment = "";

    /**
     * Fragment type.
     * @member {string} type
     * @memberof Fragment
     * @instance
     */
    Fragment.prototype.type = "";

    /**
     * Fragment nodes.
     * @member {Array.<IBlock>} nodes
     * @memberof Fragment
     * @instance
     */
    Fragment.prototype.nodes = $util.emptyArray;

    /**
     * Creates a new Fragment instance using the specified properties.
     * @function create
     * @memberof Fragment
     * @static
     * @param {IFragment=} [properties] Properties to set
     * @returns {Fragment} Fragment instance
     */
    Fragment.create = function create(properties) {
        return new Fragment(properties);
    };

    /**
     * Encodes the specified Fragment message. Does not implicitly {@link Fragment.verify|verify} messages.
     * @function encode
     * @memberof Fragment
     * @static
     * @param {IFragment} message Fragment message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    Fragment.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.key != null && Object.hasOwnProperty.call(message, "key"))
            writer.uint32(/* id 1, wireType 2 =*/10).string(message.key);
        if (message.fragment != null && Object.hasOwnProperty.call(message, "fragment"))
            writer.uint32(/* id 2, wireType 2 =*/18).string(message.fragment);
        if (message.type != null && Object.hasOwnProperty.call(message, "type"))
            writer.uint32(/* id 3, wireType 2 =*/26).string(message.type);
        if (message.nodes != null && message.nodes.length)
            for (let i = 0; i < message.nodes.length; ++i)
                $root.Block.encode(message.nodes[i], writer.uint32(/* id 4, wireType 2 =*/34).fork()).ldelim();
        return writer;
    };

    /**
     * Encodes the specified Fragment message, length delimited. Does not implicitly {@link Fragment.verify|verify} messages.
     * @function encodeDelimited
     * @memberof Fragment
     * @static
     * @param {IFragment} message Fragment message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    Fragment.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer && writer.len ? writer.fork() : writer).ldelim();
    };

    /**
     * Decodes a Fragment message from the specified reader or buffer.
     * @function decode
     * @memberof Fragment
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {Fragment} Fragment
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    Fragment.decode = function decode(reader, length, error, long) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        if (long === undefined)
            long = 0;
        if (long > $Reader.recursionLimit)
            throw Error("maximum nesting depth exceeded");
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.Fragment();
        while (reader.pos < end) {
            let tag = reader.uint32();
            if (tag === error)
                break;
            switch (tag >>> 3) {
            case 1: {
                    message.key = reader.string();
                    break;
                }
            case 2: {
                    message.fragment = reader.string();
                    break;
                }
            case 3: {
                    message.type = reader.string();
                    break;
                }
            case 4: {
                    if (!(message.nodes && message.nodes.length))
                        message.nodes = [];
                    message.nodes.push($root.Block.decode(reader, reader.uint32(), undefined, long + 1));
                    break;
                }
            default:
                reader.skipType(tag & 7, long);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a Fragment message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof Fragment
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {Fragment} Fragment
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    Fragment.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a Fragment message.
     * @function verify
     * @memberof Fragment
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    Fragment.verify = function verify(message, long) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (long === undefined)
            long = 0;
        if (long > $util.recursionLimit)
            return "maximum nesting depth exceeded";
        if (message.key != null && message.hasOwnProperty("key"))
            if (!$util.isString(message.key))
                return "key: string expected";
        if (message.fragment != null && message.hasOwnProperty("fragment"))
            if (!$util.isString(message.fragment))
                return "fragment: string expected";
        if (message.type != null && message.hasOwnProperty("type"))
            if (!$util.isString(message.type))
                return "type: string expected";
        if (message.nodes != null && message.hasOwnProperty("nodes")) {
            if (!Array.isArray(message.nodes))
                return "nodes: array expected";
            for (let i = 0; i < message.nodes.length; ++i) {
                let error = $root.Block.verify(message.nodes[i], long + 1);
                if (error)
                    return "nodes." + error;
            }
        }
        return null;
    };

    /**
     * Creates a Fragment message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof Fragment
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {Fragment} Fragment
     */
    Fragment.fromObject = function fromObject(object, long) {
        if (object instanceof $root.Fragment)
            return object;
        if (long === undefined)
            long = 0;
        if (long > $util.recursionLimit)
            throw Error("maximum nesting depth exceeded");
        let message = new $root.Fragment();
        if (object.key != null)
            message.key = String(object.key);
        if (object.fragment != null)
            message.fragment = String(object.fragment);
        if (object.type != null)
            message.type = String(object.type);
        if (object.nodes) {
            if (!Array.isArray(object.nodes))
                throw TypeError(".Fragment.nodes: array expected");
            message.nodes = [];
            for (let i = 0; i < object.nodes.length; ++i) {
                if (typeof object.nodes[i] !== "object")
                    throw TypeError(".Fragment.nodes: object expected");
                message.nodes[i] = $root.Block.fromObject(object.nodes[i], long + 1);
            }
        }
        return message;
    };

    /**
     * Creates a plain object from a Fragment message. Also converts values to other types if specified.
     * @function toObject
     * @memberof Fragment
     * @static
     * @param {Fragment} message Fragment
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    Fragment.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        let object = {};
        if (options.arrays || options.defaults)
            object.nodes = [];
        if (options.defaults) {
            object.key = "";
            object.fragment = "";
            object.type = "";
        }
        if (message.key != null && message.hasOwnProperty("key"))
            object.key = message.key;
        if (message.fragment != null && message.hasOwnProperty("fragment"))
            object.fragment = message.fragment;
        if (message.type != null && message.hasOwnProperty("type"))
            object.type = message.type;
        if (message.nodes && message.nodes.length) {
            object.nodes = [];
            for (let j = 0; j < message.nodes.length; ++j)
                object.nodes[j] = $root.Block.toObject(message.nodes[j], options);
        }
        return object;
    };

    /**
     * Converts this Fragment to JSON.
     * @function toJSON
     * @memberof Fragment
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    Fragment.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the default type url for Fragment
     * @function getTypeUrl
     * @memberof Fragment
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */
    Fragment.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/Fragment";
    };

    return Fragment;
})();

export const Inline = $root.Inline = (() => {

    /**
     * Properties of an Inline.
     * @exports IInline
     * @interface IInline
     * @property {string|null} [key] Inline key
     * @property {string|null} [type] Inline type
     * @property {Array.<INode>|null} [nodes] Inline nodes
     * @property {Object.<string,string>|null} [data] Inline data
     * @property {boolean|null} [isVoid] Inline isVoid
     * @property {Array.<IFragment>|null} [fragments] Inline fragments
     */

    /**
     * Constructs a new Inline.
     * @exports Inline
     * @classdesc Represents an Inline.
     * @implements IInline
     * @constructor
     * @param {IInline=} [properties] Properties to set
     */
    function Inline(properties) {
        this.nodes = [];
        this.data = {};
        this.fragments = [];
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null && keys[i] !== "__proto__")
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * Inline key.
     * @member {string} key
     * @memberof Inline
     * @instance
     */
    Inline.prototype.key = "";

    /**
     * Inline type.
     * @member {string} type
     * @memberof Inline
     * @instance
     */
    Inline.prototype.type = "";

    /**
     * Inline nodes.
     * @member {Array.<INode>} nodes
     * @memberof Inline
     * @instance
     */
    Inline.prototype.nodes = $util.emptyArray;

    /**
     * Inline data.
     * @member {Object.<string,string>} data
     * @memberof Inline
     * @instance
     */
    Inline.prototype.data = $util.emptyObject;

    /**
     * Inline isVoid.
     * @member {boolean} isVoid
     * @memberof Inline
     * @instance
     */
    Inline.prototype.isVoid = false;

    /**
     * Inline fragments.
     * @member {Array.<IFragment>} fragments
     * @memberof Inline
     * @instance
     */
    Inline.prototype.fragments = $util.emptyArray;

    /**
     * Creates a new Inline instance using the specified properties.
     * @function create
     * @memberof Inline
     * @static
     * @param {IInline=} [properties] Properties to set
     * @returns {Inline} Inline instance
     */
    Inline.create = function create(properties) {
        return new Inline(properties);
    };

    /**
     * Encodes the specified Inline message. Does not implicitly {@link Inline.verify|verify} messages.
     * @function encode
     * @memberof Inline
     * @static
     * @param {IInline} message Inline message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    Inline.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.key != null && Object.hasOwnProperty.call(message, "key"))
            writer.uint32(/* id 1, wireType 2 =*/10).string(message.key);
        if (message.type != null && Object.hasOwnProperty.call(message, "type"))
            writer.uint32(/* id 2, wireType 2 =*/18).string(message.type);
        if (message.nodes != null && message.nodes.length)
            for (let i = 0; i < message.nodes.length; ++i)
                $root.Node.encode(message.nodes[i], writer.uint32(/* id 3, wireType 2 =*/26).fork()).ldelim();
        if (message.data != null && Object.hasOwnProperty.call(message, "data"))
            for (let keys = Object.keys(message.data), i = 0; i < keys.length; ++i)
                writer.uint32(/* id 4, wireType 2 =*/34).fork().uint32(/* id 1, wireType 2 =*/10).string(keys[i]).uint32(/* id 2, wireType 2 =*/18).string(message.data[keys[i]]).ldelim();
        if (message.isVoid != null && Object.hasOwnProperty.call(message, "isVoid"))
            writer.uint32(/* id 6, wireType 0 =*/48).bool(message.isVoid);
        if (message.fragments != null && message.fragments.length)
            for (let i = 0; i < message.fragments.length; ++i)
                $root.Fragment.encode(message.fragments[i], writer.uint32(/* id 7, wireType 2 =*/58).fork()).ldelim();
        return writer;
    };

    /**
     * Encodes the specified Inline message, length delimited. Does not implicitly {@link Inline.verify|verify} messages.
     * @function encodeDelimited
     * @memberof Inline
     * @static
     * @param {IInline} message Inline message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    Inline.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer && writer.len ? writer.fork() : writer).ldelim();
    };

    /**
     * Decodes an Inline message from the specified reader or buffer.
     * @function decode
     * @memberof Inline
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {Inline} Inline
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    Inline.decode = function decode(reader, length, error, long) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        if (long === undefined)
            long = 0;
        if (long > $Reader.recursionLimit)
            throw Error("maximum nesting depth exceeded");
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.Inline(), key, value;
        while (reader.pos < end) {
            let tag = reader.uint32();
            if (tag === error)
                break;
            switch (tag >>> 3) {
            case 1: {
                    message.key = reader.string();
                    break;
                }
            case 2: {
                    message.type = reader.string();
                    break;
                }
            case 3: {
                    if (!(message.nodes && message.nodes.length))
                        message.nodes = [];
                    message.nodes.push($root.Node.decode(reader, reader.uint32(), undefined, long + 1));
                    break;
                }
            case 4: {
                    if (message.data === $util.emptyObject)
                        message.data = {};
                    let end2 = reader.uint32() + reader.pos;
                    key = "";
                    value = "";
                    while (reader.pos < end2) {
                        let tag2 = reader.uint32();
                        switch (tag2 >>> 3) {
                        case 1:
                            key = reader.string();
                            break;
                        case 2:
                            value = reader.string();
                            break;
                        default:
                            reader.skipType(tag2 & 7, long);
                            break;
                        }
                    }
                    if (key === "__proto__")
                        $util.makeProp(message.data, key);
                    message.data[key] = value;
                    break;
                }
            case 6: {
                    message.isVoid = reader.bool();
                    break;
                }
            case 7: {
                    if (!(message.fragments && message.fragments.length))
                        message.fragments = [];
                    message.fragments.push($root.Fragment.decode(reader, reader.uint32(), undefined, long + 1));
                    break;
                }
            default:
                reader.skipType(tag & 7, long);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes an Inline message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof Inline
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {Inline} Inline
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    Inline.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies an Inline message.
     * @function verify
     * @memberof Inline
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    Inline.verify = function verify(message, long) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (long === undefined)
            long = 0;
        if (long > $util.recursionLimit)
            return "maximum nesting depth exceeded";
        if (message.key != null && message.hasOwnProperty("key"))
            if (!$util.isString(message.key))
                return "key: string expected";
        if (message.type != null && message.hasOwnProperty("type"))
            if (!$util.isString(message.type))
                return "type: string expected";
        if (message.nodes != null && message.hasOwnProperty("nodes")) {
            if (!Array.isArray(message.nodes))
                return "nodes: array expected";
            for (let i = 0; i < message.nodes.length; ++i) {
                let error = $root.Node.verify(message.nodes[i], long + 1);
                if (error)
                    return "nodes." + error;
            }
        }
        if (message.data != null && message.hasOwnProperty("data")) {
            if (!$util.isObject(message.data))
                return "data: object expected";
            let key = Object.keys(message.data);
            for (let i = 0; i < key.length; ++i)
                if (!$util.isString(message.data[key[i]]))
                    return "data: string{k:string} expected";
        }
        if (message.isVoid != null && message.hasOwnProperty("isVoid"))
            if (typeof message.isVoid !== "boolean")
                return "isVoid: boolean expected";
        if (message.fragments != null && message.hasOwnProperty("fragments")) {
            if (!Array.isArray(message.fragments))
                return "fragments: array expected";
            for (let i = 0; i < message.fragments.length; ++i) {
                let error = $root.Fragment.verify(message.fragments[i], long + 1);
                if (error)
                    return "fragments." + error;
            }
        }
        return null;
    };

    /**
     * Creates an Inline message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof Inline
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {Inline} Inline
     */
    Inline.fromObject = function fromObject(object, long) {
        if (object instanceof $root.Inline)
            return object;
        if (long === undefined)
            long = 0;
        if (long > $util.recursionLimit)
            throw Error("maximum nesting depth exceeded");
        let message = new $root.Inline();
        if (object.key != null)
            message.key = String(object.key);
        if (object.type != null)
            message.type = String(object.type);
        if (object.nodes) {
            if (!Array.isArray(object.nodes))
                throw TypeError(".Inline.nodes: array expected");
            message.nodes = [];
            for (let i = 0; i < object.nodes.length; ++i) {
                if (typeof object.nodes[i] !== "object")
                    throw TypeError(".Inline.nodes: object expected");
                message.nodes[i] = $root.Node.fromObject(object.nodes[i], long + 1);
            }
        }
        if (object.data) {
            if (typeof object.data !== "object")
                throw TypeError(".Inline.data: object expected");
            message.data = {};
            for (let keys = Object.keys(object.data), i = 0; i < keys.length; ++i) {
                if (keys[i] === "__proto__")
                    $util.makeProp(message.data, keys[i]);
                message.data[keys[i]] = String(object.data[keys[i]]);
            }
        }
        if (object.isVoid != null)
            message.isVoid = Boolean(object.isVoid);
        if (object.fragments) {
            if (!Array.isArray(object.fragments))
                throw TypeError(".Inline.fragments: array expected");
            message.fragments = [];
            for (let i = 0; i < object.fragments.length; ++i) {
                if (typeof object.fragments[i] !== "object")
                    throw TypeError(".Inline.fragments: object expected");
                message.fragments[i] = $root.Fragment.fromObject(object.fragments[i], long + 1);
            }
        }
        return message;
    };

    /**
     * Creates a plain object from an Inline message. Also converts values to other types if specified.
     * @function toObject
     * @memberof Inline
     * @static
     * @param {Inline} message Inline
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    Inline.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        let object = {};
        if (options.arrays || options.defaults) {
            object.nodes = [];
            object.fragments = [];
        }
        if (options.objects || options.defaults)
            object.data = {};
        if (options.defaults) {
            object.key = "";
            object.type = "";
            object.isVoid = false;
        }
        if (message.key != null && message.hasOwnProperty("key"))
            object.key = message.key;
        if (message.type != null && message.hasOwnProperty("type"))
            object.type = message.type;
        if (message.nodes && message.nodes.length) {
            object.nodes = [];
            for (let j = 0; j < message.nodes.length; ++j)
                object.nodes[j] = $root.Node.toObject(message.nodes[j], options);
        }
        let keys2;
        if (message.data && (keys2 = Object.keys(message.data)).length) {
            object.data = {};
            for (let j = 0; j < keys2.length; ++j) {
                if (keys2[j] === "__proto__")
                    $util.makeProp(object.data, keys2[j]);
                object.data[keys2[j]] = message.data[keys2[j]];
            }
        }
        if (message.isVoid != null && message.hasOwnProperty("isVoid"))
            object.isVoid = message.isVoid;
        if (message.fragments && message.fragments.length) {
            object.fragments = [];
            for (let j = 0; j < message.fragments.length; ++j)
                object.fragments[j] = $root.Fragment.toObject(message.fragments[j], options);
        }
        return object;
    };

    /**
     * Converts this Inline to JSON.
     * @function toJSON
     * @memberof Inline
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    Inline.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the default type url for Inline
     * @function getTypeUrl
     * @memberof Inline
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */
    Inline.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/Inline";
    };

    return Inline;
})();

export const Text = $root.Text = (() => {

    /**
     * Properties of a Text.
     * @exports IText
     * @interface IText
     * @property {string|null} [key] Text key
     * @property {Array.<ITextLeaf>|null} [leaves] Text leaves
     */

    /**
     * Constructs a new Text.
     * @exports Text
     * @classdesc Represents a Text.
     * @implements IText
     * @constructor
     * @param {IText=} [properties] Properties to set
     */
    function Text(properties) {
        this.leaves = [];
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null && keys[i] !== "__proto__")
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * Text key.
     * @member {string} key
     * @memberof Text
     * @instance
     */
    Text.prototype.key = "";

    /**
     * Text leaves.
     * @member {Array.<ITextLeaf>} leaves
     * @memberof Text
     * @instance
     */
    Text.prototype.leaves = $util.emptyArray;

    /**
     * Creates a new Text instance using the specified properties.
     * @function create
     * @memberof Text
     * @static
     * @param {IText=} [properties] Properties to set
     * @returns {Text} Text instance
     */
    Text.create = function create(properties) {
        return new Text(properties);
    };

    /**
     * Encodes the specified Text message. Does not implicitly {@link Text.verify|verify} messages.
     * @function encode
     * @memberof Text
     * @static
     * @param {IText} message Text message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    Text.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.key != null && Object.hasOwnProperty.call(message, "key"))
            writer.uint32(/* id 1, wireType 2 =*/10).string(message.key);
        if (message.leaves != null && message.leaves.length)
            for (let i = 0; i < message.leaves.length; ++i)
                $root.TextLeaf.encode(message.leaves[i], writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
        return writer;
    };

    /**
     * Encodes the specified Text message, length delimited. Does not implicitly {@link Text.verify|verify} messages.
     * @function encodeDelimited
     * @memberof Text
     * @static
     * @param {IText} message Text message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    Text.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer && writer.len ? writer.fork() : writer).ldelim();
    };

    /**
     * Decodes a Text message from the specified reader or buffer.
     * @function decode
     * @memberof Text
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {Text} Text
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    Text.decode = function decode(reader, length, error, long) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        if (long === undefined)
            long = 0;
        if (long > $Reader.recursionLimit)
            throw Error("maximum nesting depth exceeded");
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.Text();
        while (reader.pos < end) {
            let tag = reader.uint32();
            if (tag === error)
                break;
            switch (tag >>> 3) {
            case 1: {
                    message.key = reader.string();
                    break;
                }
            case 2: {
                    if (!(message.leaves && message.leaves.length))
                        message.leaves = [];
                    message.leaves.push($root.TextLeaf.decode(reader, reader.uint32(), undefined, long + 1));
                    break;
                }
            default:
                reader.skipType(tag & 7, long);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a Text message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof Text
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {Text} Text
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    Text.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a Text message.
     * @function verify
     * @memberof Text
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    Text.verify = function verify(message, long) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (long === undefined)
            long = 0;
        if (long > $util.recursionLimit)
            return "maximum nesting depth exceeded";
        if (message.key != null && message.hasOwnProperty("key"))
            if (!$util.isString(message.key))
                return "key: string expected";
        if (message.leaves != null && message.hasOwnProperty("leaves")) {
            if (!Array.isArray(message.leaves))
                return "leaves: array expected";
            for (let i = 0; i < message.leaves.length; ++i) {
                let error = $root.TextLeaf.verify(message.leaves[i], long + 1);
                if (error)
                    return "leaves." + error;
            }
        }
        return null;
    };

    /**
     * Creates a Text message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof Text
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {Text} Text
     */
    Text.fromObject = function fromObject(object, long) {
        if (object instanceof $root.Text)
            return object;
        if (long === undefined)
            long = 0;
        if (long > $util.recursionLimit)
            throw Error("maximum nesting depth exceeded");
        let message = new $root.Text();
        if (object.key != null)
            message.key = String(object.key);
        if (object.leaves) {
            if (!Array.isArray(object.leaves))
                throw TypeError(".Text.leaves: array expected");
            message.leaves = [];
            for (let i = 0; i < object.leaves.length; ++i) {
                if (typeof object.leaves[i] !== "object")
                    throw TypeError(".Text.leaves: object expected");
                message.leaves[i] = $root.TextLeaf.fromObject(object.leaves[i], long + 1);
            }
        }
        return message;
    };

    /**
     * Creates a plain object from a Text message. Also converts values to other types if specified.
     * @function toObject
     * @memberof Text
     * @static
     * @param {Text} message Text
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    Text.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        let object = {};
        if (options.arrays || options.defaults)
            object.leaves = [];
        if (options.defaults)
            object.key = "";
        if (message.key != null && message.hasOwnProperty("key"))
            object.key = message.key;
        if (message.leaves && message.leaves.length) {
            object.leaves = [];
            for (let j = 0; j < message.leaves.length; ++j)
                object.leaves[j] = $root.TextLeaf.toObject(message.leaves[j], options);
        }
        return object;
    };

    /**
     * Converts this Text to JSON.
     * @function toJSON
     * @memberof Text
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    Text.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the default type url for Text
     * @function getTypeUrl
     * @memberof Text
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */
    Text.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/Text";
    };

    return Text;
})();

export const TextLeaf = $root.TextLeaf = (() => {

    /**
     * Properties of a TextLeaf.
     * @exports ITextLeaf
     * @interface ITextLeaf
     * @property {string|null} [text] TextLeaf text
     * @property {Array.<IMark>|null} [marks] TextLeaf marks
     */

    /**
     * Constructs a new TextLeaf.
     * @exports TextLeaf
     * @classdesc Represents a TextLeaf.
     * @implements ITextLeaf
     * @constructor
     * @param {ITextLeaf=} [properties] Properties to set
     */
    function TextLeaf(properties) {
        this.marks = [];
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null && keys[i] !== "__proto__")
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * TextLeaf text.
     * @member {string} text
     * @memberof TextLeaf
     * @instance
     */
    TextLeaf.prototype.text = "";

    /**
     * TextLeaf marks.
     * @member {Array.<IMark>} marks
     * @memberof TextLeaf
     * @instance
     */
    TextLeaf.prototype.marks = $util.emptyArray;

    /**
     * Creates a new TextLeaf instance using the specified properties.
     * @function create
     * @memberof TextLeaf
     * @static
     * @param {ITextLeaf=} [properties] Properties to set
     * @returns {TextLeaf} TextLeaf instance
     */
    TextLeaf.create = function create(properties) {
        return new TextLeaf(properties);
    };

    /**
     * Encodes the specified TextLeaf message. Does not implicitly {@link TextLeaf.verify|verify} messages.
     * @function encode
     * @memberof TextLeaf
     * @static
     * @param {ITextLeaf} message TextLeaf message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    TextLeaf.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.text != null && Object.hasOwnProperty.call(message, "text"))
            writer.uint32(/* id 1, wireType 2 =*/10).string(message.text);
        if (message.marks != null && message.marks.length)
            for (let i = 0; i < message.marks.length; ++i)
                $root.Mark.encode(message.marks[i], writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
        return writer;
    };

    /**
     * Encodes the specified TextLeaf message, length delimited. Does not implicitly {@link TextLeaf.verify|verify} messages.
     * @function encodeDelimited
     * @memberof TextLeaf
     * @static
     * @param {ITextLeaf} message TextLeaf message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    TextLeaf.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer && writer.len ? writer.fork() : writer).ldelim();
    };

    /**
     * Decodes a TextLeaf message from the specified reader or buffer.
     * @function decode
     * @memberof TextLeaf
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {TextLeaf} TextLeaf
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    TextLeaf.decode = function decode(reader, length, error, long) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        if (long === undefined)
            long = 0;
        if (long > $Reader.recursionLimit)
            throw Error("maximum nesting depth exceeded");
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.TextLeaf();
        while (reader.pos < end) {
            let tag = reader.uint32();
            if (tag === error)
                break;
            switch (tag >>> 3) {
            case 1: {
                    message.text = reader.string();
                    break;
                }
            case 2: {
                    if (!(message.marks && message.marks.length))
                        message.marks = [];
                    message.marks.push($root.Mark.decode(reader, reader.uint32(), undefined, long + 1));
                    break;
                }
            default:
                reader.skipType(tag & 7, long);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a TextLeaf message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof TextLeaf
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {TextLeaf} TextLeaf
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    TextLeaf.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a TextLeaf message.
     * @function verify
     * @memberof TextLeaf
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    TextLeaf.verify = function verify(message, long) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (long === undefined)
            long = 0;
        if (long > $util.recursionLimit)
            return "maximum nesting depth exceeded";
        if (message.text != null && message.hasOwnProperty("text"))
            if (!$util.isString(message.text))
                return "text: string expected";
        if (message.marks != null && message.hasOwnProperty("marks")) {
            if (!Array.isArray(message.marks))
                return "marks: array expected";
            for (let i = 0; i < message.marks.length; ++i) {
                let error = $root.Mark.verify(message.marks[i], long + 1);
                if (error)
                    return "marks." + error;
            }
        }
        return null;
    };

    /**
     * Creates a TextLeaf message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof TextLeaf
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {TextLeaf} TextLeaf
     */
    TextLeaf.fromObject = function fromObject(object, long) {
        if (object instanceof $root.TextLeaf)
            return object;
        if (long === undefined)
            long = 0;
        if (long > $util.recursionLimit)
            throw Error("maximum nesting depth exceeded");
        let message = new $root.TextLeaf();
        if (object.text != null)
            message.text = String(object.text);
        if (object.marks) {
            if (!Array.isArray(object.marks))
                throw TypeError(".TextLeaf.marks: array expected");
            message.marks = [];
            for (let i = 0; i < object.marks.length; ++i) {
                if (typeof object.marks[i] !== "object")
                    throw TypeError(".TextLeaf.marks: object expected");
                message.marks[i] = $root.Mark.fromObject(object.marks[i], long + 1);
            }
        }
        return message;
    };

    /**
     * Creates a plain object from a TextLeaf message. Also converts values to other types if specified.
     * @function toObject
     * @memberof TextLeaf
     * @static
     * @param {TextLeaf} message TextLeaf
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    TextLeaf.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        let object = {};
        if (options.arrays || options.defaults)
            object.marks = [];
        if (options.defaults)
            object.text = "";
        if (message.text != null && message.hasOwnProperty("text"))
            object.text = message.text;
        if (message.marks && message.marks.length) {
            object.marks = [];
            for (let j = 0; j < message.marks.length; ++j)
                object.marks[j] = $root.Mark.toObject(message.marks[j], options);
        }
        return object;
    };

    /**
     * Converts this TextLeaf to JSON.
     * @function toJSON
     * @memberof TextLeaf
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    TextLeaf.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the default type url for TextLeaf
     * @function getTypeUrl
     * @memberof TextLeaf
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */
    TextLeaf.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/TextLeaf";
    };

    return TextLeaf;
})();

export const Mark = $root.Mark = (() => {

    /**
     * Properties of a Mark.
     * @exports IMark
     * @interface IMark
     * @property {string|null} [type] Mark type
     * @property {Object.<string,string>|null} [data] Mark data
     */

    /**
     * Constructs a new Mark.
     * @exports Mark
     * @classdesc Represents a Mark.
     * @implements IMark
     * @constructor
     * @param {IMark=} [properties] Properties to set
     */
    function Mark(properties) {
        this.data = {};
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null && keys[i] !== "__proto__")
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * Mark type.
     * @member {string} type
     * @memberof Mark
     * @instance
     */
    Mark.prototype.type = "";

    /**
     * Mark data.
     * @member {Object.<string,string>} data
     * @memberof Mark
     * @instance
     */
    Mark.prototype.data = $util.emptyObject;

    /**
     * Creates a new Mark instance using the specified properties.
     * @function create
     * @memberof Mark
     * @static
     * @param {IMark=} [properties] Properties to set
     * @returns {Mark} Mark instance
     */
    Mark.create = function create(properties) {
        return new Mark(properties);
    };

    /**
     * Encodes the specified Mark message. Does not implicitly {@link Mark.verify|verify} messages.
     * @function encode
     * @memberof Mark
     * @static
     * @param {IMark} message Mark message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    Mark.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.type != null && Object.hasOwnProperty.call(message, "type"))
            writer.uint32(/* id 1, wireType 2 =*/10).string(message.type);
        if (message.data != null && Object.hasOwnProperty.call(message, "data"))
            for (let keys = Object.keys(message.data), i = 0; i < keys.length; ++i)
                writer.uint32(/* id 2, wireType 2 =*/18).fork().uint32(/* id 1, wireType 2 =*/10).string(keys[i]).uint32(/* id 2, wireType 2 =*/18).string(message.data[keys[i]]).ldelim();
        return writer;
    };

    /**
     * Encodes the specified Mark message, length delimited. Does not implicitly {@link Mark.verify|verify} messages.
     * @function encodeDelimited
     * @memberof Mark
     * @static
     * @param {IMark} message Mark message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    Mark.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer && writer.len ? writer.fork() : writer).ldelim();
    };

    /**
     * Decodes a Mark message from the specified reader or buffer.
     * @function decode
     * @memberof Mark
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {Mark} Mark
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    Mark.decode = function decode(reader, length, error, long) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        if (long === undefined)
            long = 0;
        if (long > $Reader.recursionLimit)
            throw Error("maximum nesting depth exceeded");
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.Mark(), key, value;
        while (reader.pos < end) {
            let tag = reader.uint32();
            if (tag === error)
                break;
            switch (tag >>> 3) {
            case 1: {
                    message.type = reader.string();
                    break;
                }
            case 2: {
                    if (message.data === $util.emptyObject)
                        message.data = {};
                    let end2 = reader.uint32() + reader.pos;
                    key = "";
                    value = "";
                    while (reader.pos < end2) {
                        let tag2 = reader.uint32();
                        switch (tag2 >>> 3) {
                        case 1:
                            key = reader.string();
                            break;
                        case 2:
                            value = reader.string();
                            break;
                        default:
                            reader.skipType(tag2 & 7, long);
                            break;
                        }
                    }
                    if (key === "__proto__")
                        $util.makeProp(message.data, key);
                    message.data[key] = value;
                    break;
                }
            default:
                reader.skipType(tag & 7, long);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a Mark message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof Mark
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {Mark} Mark
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    Mark.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a Mark message.
     * @function verify
     * @memberof Mark
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    Mark.verify = function verify(message, long) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (long === undefined)
            long = 0;
        if (long > $util.recursionLimit)
            return "maximum nesting depth exceeded";
        if (message.type != null && message.hasOwnProperty("type"))
            if (!$util.isString(message.type))
                return "type: string expected";
        if (message.data != null && message.hasOwnProperty("data")) {
            if (!$util.isObject(message.data))
                return "data: object expected";
            let key = Object.keys(message.data);
            for (let i = 0; i < key.length; ++i)
                if (!$util.isString(message.data[key[i]]))
                    return "data: string{k:string} expected";
        }
        return null;
    };

    /**
     * Creates a Mark message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof Mark
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {Mark} Mark
     */
    Mark.fromObject = function fromObject(object, long) {
        if (object instanceof $root.Mark)
            return object;
        if (long === undefined)
            long = 0;
        if (long > $util.recursionLimit)
            throw Error("maximum nesting depth exceeded");
        let message = new $root.Mark();
        if (object.type != null)
            message.type = String(object.type);
        if (object.data) {
            if (typeof object.data !== "object")
                throw TypeError(".Mark.data: object expected");
            message.data = {};
            for (let keys = Object.keys(object.data), i = 0; i < keys.length; ++i) {
                if (keys[i] === "__proto__")
                    $util.makeProp(message.data, keys[i]);
                message.data[keys[i]] = String(object.data[keys[i]]);
            }
        }
        return message;
    };

    /**
     * Creates a plain object from a Mark message. Also converts values to other types if specified.
     * @function toObject
     * @memberof Mark
     * @static
     * @param {Mark} message Mark
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    Mark.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        let object = {};
        if (options.objects || options.defaults)
            object.data = {};
        if (options.defaults)
            object.type = "";
        if (message.type != null && message.hasOwnProperty("type"))
            object.type = message.type;
        let keys2;
        if (message.data && (keys2 = Object.keys(message.data)).length) {
            object.data = {};
            for (let j = 0; j < keys2.length; ++j) {
                if (keys2[j] === "__proto__")
                    $util.makeProp(object.data, keys2[j]);
                object.data[keys2[j]] = message.data[keys2[j]];
            }
        }
        return object;
    };

    /**
     * Converts this Mark to JSON.
     * @function toJSON
     * @memberof Mark
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    Mark.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the default type url for Mark
     * @function getTypeUrl
     * @memberof Mark
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */
    Mark.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/Mark";
    };

    return Mark;
})();

export { $root as default };
